import { useEffect, useRef, useState } from "react";

export default function AnimatedStat({ value }) {
  const ref = useRef(null);
  const raw = String(value || "0");
  const target = Number((raw.match(/[\d.,]+/)?.[0] || "0").replace(",", "."));
  const suffix = raw.replace(/[\d.,]+/, "");
  const decimals = Number.isInteger(target) ? 0 : 1;
  const [shown, setShown] = useState(0);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      observer.disconnect();
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return setShown(target);
      const started = performance.now();
      const tick = (now) => {
        const progress = Math.min(1, (now - started) / 900);
        setShown(target * (1 - Math.pow(1 - progress, 3)));
        if (progress < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    }, { threshold: 0.4 });
    observer.observe(node);
    return () => observer.disconnect();
  }, [target]);

  return <span ref={ref} aria-label={raw}>{shown.toFixed(decimals)}{suffix}</span>;
}
